import Vue, { PropType } from "vue";
import { resizePopup } from "./resizePopup";
import OS from "js/framework/utils/OS";
import PopupHeader from "./PopupHeader";

import styles from "../css/Popup.module.css";

const POPUP_BODY_REF = "popupBody";

export default Vue.extend({
  props: {
    header: {
      type: Boolean,
      default: true,
    },
    customClasses: {
      type: Array as PropType<String[]>,
      default: [],
    },
    handleClose: Function as PropType<() => void>,
    handleResize: Function as PropType<typeof resizePopup>,
  },
  async mounted() {
    window.addEventListener("resize", this.onResize);

    await this.$nextTick();

    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      const resizeHandler = this.handleResize || resizePopup;
      
      const body = this.$refs[POPUP_BODY_REF] as HTMLDivElement;
      const btnWrapperClass = OS.desktop ? styles.buttonsWrapper : styles.buttonsWrapperMobile;
      const btnWrappers = Array.from(body.getElementsByClassName(btnWrapperClass)) as HTMLElement[];

      resizeHandler(body, ...btnWrappers);
    },
  },
  render() {
    const {
      customClasses,
      header,
      handleClose,
    } = this;

    return (
      <div class={[
        OS.desktop ? styles.container : styles.containerMobile,
        ...customClasses,
      ]} ref={POPUP_BODY_REF}>
        { header ? <PopupHeader handleClose={handleClose}/> : null }
        <div class={styles.content}>
          { (this.$slots.default ? this.$slots.default : []) }
        </div>
      </div>
    );
  },
});
